export const exceptions = [
  {
    description: 'There are multiple entries of the exact same line item.',
    score: 'high',
    title: 'Repeat Line Items',
    type: 'duplicate_line_items',
  },
  {
    description: 'The invoice is missing the required ID number.',
    score: 'high',
    title: 'No Invoice ID',
    type: 'missing_invoice_number',
  },
  {
    description: 'The invoice is missing a complete business address.',
    score: 'high',
    title: 'No Business Address',
    type: 'missing_business_address',
  },
  {
    description: 'Any line item should include item, quantity, and description.',
    score: 'high',
    title: 'Incomplete Line Items',
    type: 'incomplete_line_items',
  },
  {
    description: 'The line item totals (and tax, if present) do not equal the total amount.',
    score: 'high',
    title: 'Wrong Total',
    type: 'wrong_total',
  },
  {
    description: 'The Due Date predates the Transaction Date.',
    score: 'high',
    title: 'Wrong Date',
    type: 'wrong_date',
  },
  {
    description: 'The tax for this invoice is unusually high, exceeding 15%.',
    score: 'high',
    title: 'Excessive Tax',
    type: 'excessive_tax',
  },
  {
    description: 'This invoice is missing the required payment terms',
    score: 'high',
    title: 'Missing Payment Terms',
    type: 'missing_payment_terms',
  },
  {
    description: 'The invoice was paid in cash',
    score: 'high',
    title: 'Cash Payment',
    type: 'cash_payment',
  },
  {
    description: 'This invoice is missing the required tax',
    score: 'high',
    title: 'Missing Tax',
    type: 'missing_tax',
  },
  {
    description: 'This invoice is missing the required vendor name',
    score: 'high',
    title: 'Missing Vendor',
    type: 'missing_vendor',
  },
  {
    description: 'This invoice is missing the required bank name',
    score: 'high',
    title: 'Missing Bank Name',
    type: 'missing_bank_name',
  },
  {
    description: 'This invoice is missing the required bank routing number',
    score: 'high',
    title: 'Missing Bank Routing Number',
    type: 'missing_bank_routing_number',
  },
  {
    description: 'This invoice is missing the required bank account number',
    score: 'high',
    title: 'Missing Bank Account Number',
    type: 'missing_bank_account_number',
  },
]

export const riskScoreFieldMapping = {
  duplicate_line_items: 'lineItems',
  missing_invoice_number: 'DocNumber',
  missing_bank_name: 'Bank Name',
  missing_bank_routing_number: 'Bank Routing No',
  missing_bank_account_number: 'Bank Account No',
  missing_business_address: 'MerchantAddress',
  missing_payment_terms: 'Payment Terms',
  cash_payment: 'Payment Method',
  excessive_tax: 'Tax Amount',
  missing_tax: 'Tax Amount',
  wrong_total: 'Total',
  missing_vendor: 'Vendor Name',
  missing_grand_total: 'Grand Total',
}

export const paymentsFilterFields = [
  'createdDate',
  'dueDate',
  'transactionDate',
  'dates',
  'currencies',
  'merchants',
  'grandTotal',
  'fileName',
]
export const expenseFilterFields = [
  'createdDate',
  'currencies',
  'dates',
  'documentTypes',
  'dueDate',
  'riskScores',
  'exceptions',
  'expenseCategories',
  'glCodes',
  'grandTotal',
  'jobCodes',
  'merchants',
  'paymentStatuses',
  'paymentTypes',
  'riskScore',
  'transactionDate',
  'members',
  'workflowStatuses',
  'docNumbers',
  'sources',
  'fileName',
]
